<template>
<ion-input
    type="text"
    inputmode="text"
    pattern="text"
    :required="field.required"
    :value="value.value"
    @ionInput="value.value = $event.target.value"></ion-input>
</template>

<script>
import Field from "../models/Field";
import Value from "../models/Value";
export default {
  name: "field-text",
  components: {},
  props: ["field", "value"],
}
</script>

<style scoped>

</style>